"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pathMatch = _interopRequireDefault(require("path-match"));
var route = (0, _pathMatch["default"])();
var languages = function languages(_languages) {
  return (_languages ? _languages : global.__appConfig__.languages).split(",").reduce(function (lang, elem) {
    lang[elem] = elem;
    return lang;
  }, {});
};
var getLanguageFromUrl = function getLanguageFromUrl(url, langs) {
  if (url[0] !== "/") {
    url = "/".concat(url);
  }
  var lang = route("/:subpath(".concat(Object.values(languages(langs)).join("|"), ")(.*)"))(url);
  return lang ? lang.subpath : "";
};
var _default = getLanguageFromUrl;
exports["default"] = _default;